(() => {
  function ready() {
    const params = new URLSearchParams(location.search);
    const requestedProduct = params.get('product');
    if (params.get('enquiry') === 'delivery') {
      document.querySelectorAll('select').forEach(select => {
        const option = [...select.options].find(option => option.value === 'Delivery or pickup');
        if (option && (!select.value || select.value === 'General enquiry')) select.value = option.value;
      });
    }
    const requirements = document.getElementById('tj-body');
    if (requestedProduct && requirements && !requirements.value.trim()) requirements.value = requestedProduct.slice(0, 250);
    if (!document.body.dataset.reviewPreviewLinks) {
      document.body.dataset.reviewPreviewLinks = 'true';
      const theme = window.Shopify?.theme;
      const draft = params.get('preview_theme_id') || (theme?.role === 'unpublished' ? String(theme.id) : null);
      function keepDraft(link) {
        if (!draft) return;
        try {
          const raw = link.getAttribute('href');
          if (!raw || raw.startsWith('#')) return;
          const url = new URL(raw, location.href);
          if (url.origin !== location.origin || !/^\/(?:pages|collections|products|policies|cart|search|$)/.test(url.pathname)) return;
          url.searchParams.set('preview_theme_id', draft);
          link.href = url.pathname + url.search + url.hash;
        } catch (_) {}
      }
      document.querySelectorAll('a[href]').forEach(keepDraft);
      document.addEventListener('click', e => { const link = e.target.closest('a[href]'); if (link) keepDraft(link); }, true);
      if (draft) document.querySelectorAll('form[role="search"]').forEach(form => {
        if (!form.querySelector('[name="preview_theme_id"]')) {
          const field = document.createElement('input');field.type = 'hidden';field.name = 'preview_theme_id';field.value = draft;form.append(field);
        }
      });
    }
    if (location.pathname === '/policies/shipping-policy') {
      const heading = document.querySelector('.shopify-policy__title h1');
      if (heading) heading.textContent = document.documentElement.lang.startsWith('en') ? 'Delivery & Pickup' : heading.textContent;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();

